import { cn } from "@/lib/utils";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "success" | "warning" | "danger" | "outline";
  className?: string;
}

const variants = {
  default: "bg-blue-100 text-blue-700 dark:bg-blue-950/50 dark:text-blue-300",
  success: "bg-green-100 text-green-700 dark:bg-green-950/45 dark:text-green-300",
  warning: "bg-yellow-100 text-yellow-700 dark:bg-yellow-950/40 dark:text-yellow-200",
  danger: "bg-red-100 text-red-700 dark:bg-red-950/45 dark:text-red-300",
  outline: "border border-gray-300 text-gray-600 dark:border-gray-600 dark:text-gray-300",
};

export default function Badge({ children, variant = "default", className }: BadgeProps) {
  return (
    <span className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium", variants[variant], className)}>
      {children}
    </span>
  );
}
